export const RANKING_TABS = [
  { slug: 'player', type: 'itempoints', label: 'PLAYER', icon: 'user' },
  { slug: 'gold', type: 'gold', label: 'GOLD', icon: 'diamond' },
  { slug: 'uniques', type: 'uniques', label: 'UNIQUES', icon: 'paw' },
  { slug: 'battle', type: 'battle', label: 'BATTLE', icon: 'shield' },
  { slug: 'job', type: 'job', label: 'JOB', icon: 'briefcase' },
  { slug: 'season', type: 'season', label: 'SEASON RANK', icon: 'trophy' },
] as const;
export type RankingCategory = typeof RANKING_TABS[number]['slug'];
export function formatGold(value: string): string {
  const gold = BigInt(value);
  for (const [unit, divisor] of [['B', 1000000000n], ['M', 1000000n], ['K', 1000n]] as const) {
    if (gold >= divisor) {
      const rounded = (gold * 100n + divisor / 2n) / divisor;
      return `${rounded / 100n}.${String(rounded % 100n).padStart(2, '0')}${unit}`;
    }
  }
  return value;
}

export function rankingOrigin(value: string | null): RankingCategory {
  return RANKING_TABS.find(tab => tab.slug === value)?.slug ?? 'player';
}
